<template>
  <card-seplag titulo="Reset Cadastro">
    <div class="p-col-12">
      <div class="p-grid p-fluid">
        <Rotulo nome="BUSCAR USUÁRIO" cols="12 4">
          <InputText
            class="classe-input"
            type="text"
            placeholder="Insira uma matrícula, nome ou CPF"
            v-model="pesquisa"
            @keyup.enter="listarCadastros()"
          />
        </Rotulo>
        <Rotulo cols="12 4">
          <Button
            icon="pi pi-search"
            label="Pesquisar"
            class="classe-button"
            @click="listarCadastros()"
          />
        </Rotulo>
      </div>
    </div>
    <Rotulo cols="12"> 
      <table-seplag :dados.sync="dados" :campos="campos" :loading="true">
        <Column headerStyle="width:15rem;" header="Vínculos">
          <template #body="slotProps">
            <span class="mobile"><b>Vínculos:</b></span>
            <div
              v-for="vinculos in slotProps.data.vinculosCiclo"
              v-bind:key="vinculos.textoVinculoUnidade"
            >
              {{ vinculos.textoVinculoUnidade }}
            </div>
          </template>
        </Column>
        <Column header="Alterar" headerStyle="width:5rem">
          <template #body="slotProps">
            <Button
              icon="pi pi-pencil"
              class="classe-button"
              style="border-radius: 20px"
              @click="abreDialog(slotProps)"
            />
          </template>
        </Column>
      </table-seplag>
    </Rotulo>
    <div class="p-col-12">
      <div class="p-grid p-fluid">
        <Rotulo cols="12 4">
          <Button
            icon="pi pi-angle-left"
            label="Voltar"
            class="classe-button"
            @click="botaoRota"
          />
        </Rotulo>
        <Rotulo cols="12 4" />
        <!-- <Rotulo cols="12 4">
          <Button
            icon="pi pi-pencil"
            label="Resetar"
            class="classe-button p-button-danger"
            @click="abrirModalConfirmacao"
          />
        </Rotulo> -->
      </div>
    </div>

    <Dialog
      header="ATENÇÃO! Resetar Recadastramento"
      :visible.sync="modalConfirmacao"
      :contentStyle="'max-width:40rem;'"
    >
      <div class="p-grid p-fluid">
        <div class="p-col-12" v-if="dadosModal != null">
          <Fieldset legend="Servidor">
            <Rotulo cols-="12">
              <span
                ><strong>Matrícula:</strong>
                {{ dadosModal.numrMatricula }}</span
              >
            </Rotulo>
            <Rotulo cols-="12">
              <span
                ><strong>Servidor:</strong> {{ dadosModal.nomePessoa }}</span
              >
            </Rotulo>
          </Fieldset>
         
          <Rotulo cols-="12" nome="Justificativa de Reset de Recadastramento:" requerido>
            <Textarea
              rows="5"
              cols="55"
              placeholder="Texto da justificativa..."
              v-model="dadosDetalhes"
            ></Textarea>
          </Rotulo>
          <Button
            icon="pi pi-check"
            label="Confirmar"
            class="p-button-success classe-button"
            @click="botaoReset()"
          />
        </div>
      </div>
    </Dialog>
  </card-seplag>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import { baseApiUrl } from "../../config/global";
import TableSeplag from "@/template/TableSeplag.vue";

export default {
  components: { CardSeplag, Rotulo, TableSeplag },

  data: function() {
    return {
      valorReset: [],
      modalConfirmacao: false,
      pesquisa: null,
      dados: [],
      campos: [
        {
          nome: "numrMatricula",
          titulo: "Matrícula",
          tamanho: "11.vw",
          alinhamento: "left",
        },
        {
          nome: "numrCpfFormatado",
          titulo: "CPF",
          tamanho: "9.vw",
          alinhamento: "left",
        },
        {
          nome: "nomePessoa",
          titulo: "Servidor",
          tamanho: "20.vw",
          alinhamento: "left",
        },
      ],
      dadosDetalhes: null,
      dadosModal: null,
    };
  },

  methods: {
    abreDialog(dados) {
      this.abrirModalConfirmacao(dados);
    },

    abrirModalConfirmacao(dados) {
      
      //this.dadosDetalhes = dados.data;
      this.dadosModal = dados.data;
      this.modalConfirmacao = true;
    },

    fecharModalConfirmacao() {
      this.modalConfirmacao = false;
    },
    listarCadastros() {
      
      if (this.pesquisa != null) {
        this.$http
          .get(`${baseApiUrl}/ciclopessoas/pesquisa/${this.pesquisa}`)
          .then((res) => [(this.dados = res.data.content)]);
        this.pesquisa = null;
      } else if (this.pesquisa == null || this.pesquisa == " ") {
        this.$http
          .get(`${baseApiUrl}/ciclopessoas/pesquisa/todos`)
          .then((res) => [(this.dados = res.data.content)]);
      }
    },
    botaoRota() {
      this.$router.push({ name: "CONSULTA_CADASTRO" });
    },
    botaoReset() {
      let param = this.$store.getters.getUser.contaAcesso.id;
      
      let body = {
        idenCicloPessoa: this.dadosModal.idenCicloPessoa,
        idenContaAcesso: param,
        motivo: this.dadosDetalhes,
      };
      this.$http
        .post(
          `${baseApiUrl}/histresetciclopessoas/resetar`,
          JSON.stringify(body)
        )
        .then(() => {
          this.modalConfirmacao = false;
          this.$toast.add({
            severity: "success",
            summary: "Ação efetuada",
            detail: "Reset de cadastro concluído com sucesso",
            life: 5000,
          });
        });
    },
  },

  mounted() {},
};
</script>

<style scoped>
.classe-input {
  width: 100%;
  margin-right: 0.5rem;
  /* margin: auto 0.5rem; */
}

.classe-button {
  display: flex;
  margin-left: 0.4rem;
  max-height: 40px;
  margin-top: 16px;
}

.titulo-button {
  font-size: 16px;
}

@media screen and (max-width: 425px) {
  .classe-input {
    margin-bottom: 0.5rem;
    /* margin: auto 0.5rem; */
  }
  .classe-button {
    margin-left: 0.4rem;
    max-height: 40px;
    margin-top: 16px;
  }
}
.desktop {
  display: block;
  /* ou inline, inline-block */
}

.mobile {
  display: none;
}
@media(max-width: 639px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
    /* ou inline, inline-block */
  }
}
</style>

<style>
.column-acoes {
  width: 20rem;
}

.button-icon {
  font-size: 1.5rem;
}

@media screen and (min-width: 481px) and (max-width: 1080px) {
  .column-acoes {
    width: 5rem;
  }

  .button-acoes > button > span {
    display: none;
  }

  .button-acoes > button {
    padding: 0.5rem 0.69rem;
  }

  .button-icon {
    font-size: 1.5rem;
  }
}
</style>
